// src/components/ui/GeometricBackground.jsx
import React from 'react';

/** Renders nothing, floating circles/squares in background were removed app-wide. */
const GeometricBackground = () => {
  return null;
};

export default GeometricBackground;
